export const TasklistsTitlePropMap = {
    tasklistId: 'Tasklist ID',
    largeScaleEventName: 'LSE Name',
    eventName: 'Event Name',
    title: 'Tasklist Name',
    country: 'Country',
    state: 'State',
    city: 'City',
    siteCode: 'Sites',
    siteId: 'Site ID',
    facilityType: 'Facility Type',
    businessLine: 'Business Line',
    gsoCluster: 'WWOS Cluster',
    numTasks: '# Tasks',
    numCompleted: '# Completed Tasks',
    completionRate: '% Completed',
    status: 'Status',
    start: 'Start',
    end: 'End',
    reasons: 'Reasons',
    durationSeconds: 'Duration',
    lastUpdateTime: 'Last Update Time'
} as const;

export const TasklistsPropMap = {
    tasklistId: 'tasklistId',
    largeScaleEventName: 'largeScaleEventName',
    eventName: 'eventName',
    title: 'title',
    country: 'country',
    state: 'state',
    city: 'city',
    siteCode: 'siteCode',
    siteId: 'siteId',
    facilityType: 'facilityType',
    businessLine: 'businessLine',
    gsoCluster: 'gsoCluster',
    numTasks: 'numTasks',
    numCompleted: 'numCompleted',
    completionRate: 'completionRate',
    status: 'status',
    start: 'start',
    end: 'end',
    reasons: 'reasons',
    durationSeconds: 'durationSeconds',
    lastUpdateTime: 'lastUpdateTime'
} as const;

export type TasklistsTitleKey = keyof typeof TasklistsTitlePropMap;
export type TasklistsPropKey = keyof typeof TasklistsPropMap;

export const TASKLIST_TEXT_FILTERABLE_FIELDS = [
    TasklistsPropMap.largeScaleEventName,
    TasklistsPropMap.eventName,
    TasklistsPropMap.title,
    TasklistsPropMap.country,
    TasklistsPropMap.state,
    TasklistsPropMap.city,
    TasklistsPropMap.siteCode,
    TasklistsPropMap.gsoCluster,
    TasklistsPropMap.reasons
] as const;

export type TextFilterField = typeof TASKLIST_TEXT_FILTERABLE_FIELDS[number];
